import React, { useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import { noop } from 'rxjs'
import useResizeObserver from 'use-resize-observer'
import Loading from '../../components/Loading/Loading'
import AggressorModal from '../../components/Modal/AggressorModal/AggressorModal'
import { useOpenFin } from '../../helpers/hooks/useOpenFin'
import {
  newSubscription,
  removeSubscription
} from '../../store/depthOfMarket/actions'
import { getDepthOfMarketOrder } from '../../store/depthOfMarket/selectors'
import { fetchSecuritiesByIds } from '../../store/securities/actions'
import {
  getQuoteReliability,
  getSecurityStaticDataById
} from '../../store/securities/selectors'
import { useAppDispatch, useAppSelector } from '../../store/types'
import { openAggressorWindow } from '../../store/windows/actions'
import { getAggressorWindows } from '../../store/windows/selectors'

const OpenFinAggressor = () => {
  const { initialId, securityId } = useParams()
  const dispatch = useAppDispatch()
  const { changeDimensions } = useOpenFin()
  const quoteReliability = useAppSelector(getQuoteReliability)(0)
  const security = useAppSelector(getSecurityStaticDataById)(Number(securityId))
  const depthOrder = useAppSelector(getDepthOfMarketOrder)(
    initialId!,
    Number(securityId)
  )
  const aggressorWindows = useAppSelector(getAggressorWindows)
  const windowInfo = aggressorWindows.find(
    (win) => win.initialOrderId === initialId
  )
  const lastHeightRef = useRef<number | undefined>()
  const { ref, height } = useResizeObserver<HTMLDivElement>()

  // 1: fetch security info
  useEffect(() => {
    dispatch(fetchSecuritiesByIds([Number(securityId)]))
  }, [dispatch, securityId])

  // 2: subscribe to depth orders
  useEffect(() => {
    if (security) {
      dispatch(newSubscription(0, Number(securityId), quoteReliability, false))
    }
    return () => {
      dispatch(removeSubscription(0, Number(securityId), false))
    }
  }, [dispatch, securityId, security, quoteReliability])

  // 3: open the aggressor window
  useEffect(() => {
    if (depthOrder) {
      dispatch(openAggressorWindow(initialId!, Number(securityId)))
    }
  }, [depthOrder, initialId, dispatch, securityId])

  // 4: adjust the window size
  useEffect(() => {
    if (height && height !== lastHeightRef.current) {
      changeDimensions(`Aggressor/${initialId}/${securityId}`, 415, height)
      lastHeightRef.current = height
    }
  }, [height, initialId, securityId, changeDimensions])

  if (!windowInfo) return <Loading />
  return (
    <div ref={ref}>
      <AggressorModal windowInfo={windowInfo} handleMinimize={noop} index={1} />
    </div>
  )
}
export default OpenFinAggressor
